<template>
  <el-dialog
    v-drag
    title="编辑费用细类名称"
    :visible.sync="dialogVisible"
    width="440px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <el-form ref="form" v-loading="loading" :model="form" :rules="rules" class="form" label-position="top">
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入名称"
          style="width: 320px"
        ></el-input>
      </el-form-item>
      <el-form-item label="应收单位" prop="arUnit">
        <el-select
          v-model="form.arUnit"
          style="width: 320px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in config.feeNameUnitTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应付单位" prop="apUnit">
        <el-select
          v-model="form.apUnit"
          style="width: 320px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in config.feeNameUnitTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="footers">
      <div v-loading="loading" class="cancel flex_c_c" @click="cancel">取 消</div>
      <div v-loading="loading" class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
import { updateFeeName } from '@/api/fee'
import config from '@/utils/config'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      config,
      form: {
        name: '',
        arUnit: '',
        apUnit: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        arUnit: [
          { required: true, message: '请选择应收单位', trigger: 'change' }
        ],
        apUnit: [
          { required: true, message: '请选择应付单位', trigger: 'change' }
        ]
      },
      loading: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        const { name, arUnit, apUnit } = this.editData
        this.form = {
          name, arUnit, apUnit
        }
        this.$refs['form']?.resetFields()
      }
    }
  },
  methods: {
    cancel() {
      this.form = {
        name: '',
        arUnit: '',
        apUnit: ''
      }
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.loading = true
          try {
            const params = {
              ...this.form,
              feeNameId: this.editData.id
            }
            const res = await updateFeeName(params)
            this.loading = false
            if (res.success) {
              this.$emit('ok')
              this.$message.success(res.errorMessage)
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.error(error)
            this.loading = false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  width: calc(100% - 80px);
  margin: 0 auto;
}
.footers {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #EEEEEE;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
